import { useQuery } from '@tanstack/react-query'
import { api } from '@api'

export interface ScrapedProfile {
  username: string | null
  fullName: string | null
  firstName: string | null
  lastName: string | null
  avatarUrl: string | null
  bio: string | null
  profileUrl: string | null
}

export interface SocialImportResultsResponse {
  items: ScrapedProfile[]
  total: number
  offset: number
  limit: number
  alreadyImportedUsernames: string[]
}

const fetchSocialImportResults = async (
  importId: string,
  offset: number,
  limit: number,
): Promise<SocialImportResultsResponse> => {
  const { data } = await api.get<SocialImportResultsResponse>(
    `/ft_import-contacts/${importId}/results`,
    { params: { offset, limit } },
  )
  return data
}

export const useFtGetSocialImportResults = (
  importId: string | null,
  offset: number = 0,
  limit: number = 50,
  enabled: boolean = true,
) => {
  return useQuery<SocialImportResultsResponse>({
    queryKey: ['ft_social_import_results', importId, offset, limit],
    queryFn: () => fetchSocialImportResults(importId!, offset, limit),
    enabled: !!importId && enabled,
  })
}
